import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

export const wrapper = style({
  position: 'relative',
  cursor: 'pointer',
  userSelect: 'none',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  width: '100%',
  gap: '0.25rem',
});

export const input = style({
  appearance: 'none',
  position: 'absolute',
  opacity: 0,
  width: 0,
  height: 0,
});

export const checkboxIcon = style({
  flexShrink: 0,
  selectors: {
    [`${input}:focus-visible ~ &`]: {
      outline: '2px solid currentColor',
      outlineOffset: '2px',
      borderRadius: '2px',
    },
  },
});

export const labelText = style({
  flex: 1,
  fontFamily: themeVars.font.Roboto,
  fontSize: '1rem',
  color: 'rgb(49, 49, 49)',
  lineHeight: '1.5',
  '@media': {
    'screen and (max-width: 450px)': { fontSize: '0.8rem' },
  },
});

export const labelError = style({
  color: themeVars.color.error,
});

export const errorMessage = style({
  width: '100%',
  color: themeVars.color.error,
  fontSize: '0.75rem',
  fontWeight: 'bold',
});
